<template>
  <div>
    <el-row class="login_pre">
      <!--登录-->
      <el-col :span="24" class="login">
        <div class="office_system">办公系统</div>
        <el-row>

          <el-col
            :span="20"
            :offset="2"
            v-if="userInfo != null && userInfo.type == '投稿人'"
            ><el-button
              :plain="true"
              class="login_button"
              @click="authorCentor()"
              style="background-color: #ff8041; color: white"
              >投稿中心</el-button
            >
          </el-col>
          <el-col :span="20" :offset="2" v-else
            ><el-button :plain="true" class="login_button" @click="authorLogin"
              >作者投稿</el-button
            >
          </el-col>

          <el-col
            :span="20"
            :offset="2"
            v-if="userInfo != null && userInfo.type == '审稿人'"
            ><el-button
              :plain="true"
              style="background-color: #ff8041; color: white"
              class="login_button"
              @click="expertCentor"
              >审稿中心</el-button
            >
          </el-col>
                    <el-col :span="20" :offset="2" v-else
            ><el-button :plain="true" class="login_button" @click="expertLogin"
              >专家审稿</el-button
            >
          </el-col>

          <el-col
            :span="20"
            :offset="2"
            v-if="userInfo != null && userInfo.type == '责任编辑'"
            ><el-button
              :plain="true"
              class="login_button"
              style="background-color: #ff8041; color: white"
              @click="editorCentor"
              >编辑中心</el-button
            >
          </el-col>
                    <el-col :span="20" :offset="2" v-else
            ><el-button :plain="true" class="login_button" @click="editorLogin"
              >编辑工作</el-button
            >
          </el-col>
        </el-row>
      </el-col>
      <!--过刊检索-->
      <el-col :span="24" class="old_journal">
        <div class="searching">过刊检索</div>
        <el-row style="margin-top: 10px">
          <el-row>
            <el-col style="height: 50px; margin-top: 10px">
              <el-date-picker
                v-model="search.year"
                type="year"
                placeholder="全部年"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 90%"
              >
              </el-date-picker>
            </el-col>
            <el-col style="height: 50px; margin-top: 1px">
              <el-select
                v-model="search.period"
                placeholder="全部期"
                style="width: 90%"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row style="height: 50px; margin-top: 1px">
            <el-input
              v-model="search.title"
              placeholder="文章题目"
              style="width: 90%"
            ></el-input
          ></el-row>
          <el-row style="height: 50px; margin-top: 1px">
            <el-input
              v-model="search.name"
              placeholder="作者姓名"
              style="width: 90%; height: 90px"
            ></el-input>
            <br />
            <br
          /></el-row>
          <el-row style="height: 50px; margin-top: 1px">
            <el-input
              v-model="search.unit"
              placeholder="作者单位"
              style="width: 90%; height: 90px"
            ></el-input
          ></el-row>
          <el-row style="height: 50px; margin-top: 1px">
            <el-input
              v-model="search.keywords"
              placeholder="关键词"
              style="width: 60%"
            ></el-input>
            <el-button
            @click="getFuzzySearch()"
              type="primary"
              style="
                width: 30%;
                background-color: #ff8041;
                font-weight: 500;
                border: 1px solid #b3c0d1;
                color: white;
              "
              >搜索</el-button
            >
          </el-row>
        </el-row>
      </el-col>
      <!--友情链接-->
      <el-col :span="24" class="frendly_pre">
        <div class="my_link">友情链接</div>

        <el-row class="frendly_detail">
          <el-col
            v-for="(item, index) in linkList"
            :key="index"
            style="margin-bottom: 10px; margin-top: 10px"
          >
            <span class="dot"> </span>
            <a target="_blank" class="href" :href="item.linkUrl">{{
              item.name
            }}</a>
          </el-col>
        </el-row>
      </el-col>
      <el-col
        :span="24"
        style="
          padding-top: 10px;
          border-radius: 10px;
          border: 1px solid #b3c0d1;
          margin-bottom: 10px;
          background-color: white;
        "
        ><img
          src="../../static/materials/code.jpg"
          style="width: 130px; height: 130px"
      /></el-col>
    </el-row>
  </div>
</template>

<script>
import { fuzzySearch } from '@/api/data'
export default {
  name: 'LoginComponent',
  inject: ['reload'],
  data () {
    return {
      needShow: false,
      search: {
        year: '',
        period: null,
        title: null,
        name: null,
        unit: null,
        keywords: null
      },
      userInfo: {
        email: null,
        type: null
      },
      value3: '',
      activeIndex: '1',
      activeIndex2: '1',
      options: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '第1期',
          label: '第1期'
        },
        {
          value: '第2期',
          label: '第2期'
        },
        {
          value: '第3期',
          label: '第3期'
        },
        {
          value: '第4期',
          label: '第4期'
        }
      ],
      value: '',
      linkList: [
        { name: '南开语言学刊', linkUrl: 'http://nkyk.cbpt.cnki.net' },
        {
          name: '口音汉语在线',
          linkUrl: 'http://www.globalaccentchinese.com/'
        },
        {
          name: '中国语音学报',
          linkUrl: 'https://navi.cnki.net/knavi/jjournals/ZYUB/detail'
        },
        { name: '中国知网(cnki.net)', linkUrl: 'ScienceDirect.com' },
        { name: '当代语言学', linkUrl: 'http://www.ddyyx.com/' },
        { name: '语言文字应用', linkUrl: 'http://www.yywzyyzz.cn/' },
        {
          name: '语言科学',
          linkUrl:
            'http://journal15.magtechjournal.com/Jwk_yykx/CN/volumn/current.shtml'
        },
        {
          name: '世界汉语教学',
          linkUrl:
            'http://sjhy.cbpt.cnki.net/WKC2/WebPublication/index.aspx?mid=SJHY'
        },
        {
          name: '语言教学与研究',
          linkUrl:
            'http://yyjx.cbpt.cnki.net/WKB3/WebPublication/index.aspx?mid=YYJX'
        },
        {
          name: '外语教学与研究',
          linkUrl:
            'http://www.fltr.ac.cn/WKG/WebPublication/index.aspx?mid=wjyy'
        },
        {
          name: 'Journal of Chinese Linguistics 中国语言学报',
          linkUrl: 'http://www.cuhk.edu.hk/journal/jcl/pub_cl_vol.htm'
        },
        {
          name: '心理学报',
          linkUrl: 'https://journal.psych.ac.cn/xlxb/CN/0439-755X/home.shtml'
        },
        {
          name: '声学学报',
          linkUrl:
            'https://xiba.chinajournal.net.cn/WKC/WebPublication/index.aspx?mid=xiba'
        },
        {
          name: '应用声学',
          linkUrl: 'http://yysx.cnjournals.cn/ch/index.aspx'
        },
        {
          name: 'Journal of Phonetics',
          linkUrl: 'https://www.sciencedirect.com/journal/journal-of-phonetics'
        },
        {
          name: 'Lingua',
          linkUrl: 'https://www.sciencedirect.com/journal/lingua'
        },
        {
          name: 'Phonetica',
          linkUrl: 'https://www.degruyter.com/journal/key/phon/html'
        },
        {
          name: 'International Journal of Language and Communication Disorder',
          linkUrl:
            'https://onlinelibrary.wiley.com/page/journal/14606984/homepage/forauthors.html '
        },
        {
          name: 'Journal of Memory and Language',
          linkUrl:
            'https://www.sciencedirect.com/journal/journal-of-memory-and-language'
        },
        {
          name: 'Journal of Speech,Language,and Hearing Research',
          linkUrl: 'https://pubs.asha.org/journal/jslhr'
        },
        {
          name: 'The Modern Language Journal',
          linkUrl: 'https://onlinelibrary.wiley.com/journal/15404781'
        },
        {
          name: 'Language Learning',
          linkUrl: 'https://onlinelibrary.wiley.com/journal/14679922'
        },
        {
          name: 'Brain and Language',
          linkUrl: 'https://www.sciencedirect.com/journal/brain-and-language'
        },
        {
          name: 'Language Cognition and Neuroscience',
          linkUrl:
            'https://www.tandfonline.com/action/journalInformation?journalCode=plcp2'
        },
        {
          name: 'Journal of the Acoustical Society of America',
          linkUrl: 'https://asa.scitation.org/jas/info/about'
        }
      ]
    }
  },
  methods: {
    authorLogin () {
      const login = this
      login.$router.push({ name: 'login', query: { roleFlag: '投稿人' } })
    },
    expertLogin () {
      const login = this
      login.$router.push({ name: 'login', query: { roleFlag: '审稿人' } })
    },
    editorLogin () {
      const login = this
      login.$router.push({ name: 'login', query: { roleFlag: '责任编辑' } })
    },
    authorCentor () {
      const switchTo = this
      switchTo.$router.push({ name: 'manuscriptList' })
    },
    expertCentor () {
      const switchTo = this
      switchTo.$router.push({
        name: 'reviewerList'
      })
    },
    editorCentor () {
      const switchTo = this
      switchTo.$router.push({ name: 'editorList' })
    },
    back () {
      this.$router.push({ name: 'manuscriptsList' })
      console.log(1)
      this.reload()
    },
    getFuzzySearch () {
      window.search = this.search
      this.back()
    }
  },
  mounted () {
    this.userInfo = this.$cookie.getCookie('userInfo')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
  color: #006a71;
}
.login_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
}

.dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #ff8041;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  text-align: left;
  margin-right: 10px;
}
.login {
  height: 210px;
  border-radius: 5px;
  border: 1px solid #b3c0d1;
  margin-bottom: 10px;
}
.login_button {
  width: 100%;
  height: 40px;
  margin-top: 10px;
}
.login_button:hover {
  background-color: #ff8041;
  color: white;
  border: none;
}
.login_button:active {
  background-color: #ff8041;
  border: none;
}
.frendly_detail {
  text-align: left;
  margin-left: 10px;
  font-size: 14px;
  overflow: auto;
  height: 360px;
}
.old_journal {
  background-color: white;
  margin-bottom: 10px;
  margin-top: 10px;
  border-radius: 10px;
  border: 1px solid #b3c0d1;
}
.frendly_pre {
  margin-top: 10px;
  border-radius: 10px;
  border: 1px solid #b3c0d1;
  margin-bottom: 10px;
  text-align: left;
  overflow: hidden;
  height: 410px;
}

.office_system,
.my_link {
  background-image: linear-gradient(#006a71, #005152, #002412);
  height: 30px;
  line-height: 30px;
  text-align: left;
  padding-left: 10px;
  color: white;
  font-size: 14px;
  border-radius: 5px;
  font-weight: 900;
  margin-top: 10px;
  margin-left: 10px;
}
.searching {
  background-image: linear-gradient(#006a71, #005152, #002412);
  height: 30px;
  line-height: 30px;
  text-align: left;
  padding-left: 10px;
  color: white;
  font-size: 14px;
  border-radius: 5px;
  font-weight: 900;
  margin-top: 10px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/loginComponent.vue